import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ClienteIntegracoesService } from '../services/integracoes/cliente-integracoes.service';

@Injectable({ providedIn: 'root' })
export class ClienteIntegracoesGuard implements CanActivate {
  constructor(private router: Router, private toastr: ToastrService) {}
  canActivate(): boolean | UrlTree {
    if (!ClienteIntegracoesService.permitido()) {
      this.toastr.warning('Seu usuário não possui acesso a este painel.', 'Acesso restrito');
      return this.router.createUrlTree(['/pedidos']);
    }
    if (!localStorage.getItem('cliente_integracoes_token')) {
      this.toastr.info('Saia e entre novamente no portal para habilitar os novos menus de integrações.');
      return this.router.createUrlTree(['/pedidos']);
    }
    return true;
  }
}
